import React from "react"
import {OpportunityTag, getOpportunityTagLabel} from "@casas-diamante/types"

interface OpportunityTagBadgeProps {
   tag?: OpportunityTag | null
   className?: string
}

const OpportunityTagBadge = ({tag, className = ""}: OpportunityTagBadgeProps) => {
   if (!tag) return null

   const badgeSrc =
      tag === OpportunityTag.UniqueOpportunity
         ? "/tags/oportunidad_unica_morada.svg"
         : tag === OpportunityTag.Opportunity
         ? "/tags/oportunidad_roja.svg"
         : undefined

   if (!badgeSrc) return null

   const altText = getOpportunityTagLabel(tag) ?? "Oportunidad"

   return <img src={badgeSrc} alt={altText} className={`h-[30px] w-xs ${className}`} />
}

export default OpportunityTagBadge
